var map = {
	"./all_screen.png": 4187,
	"./btnborder_y.png": 3937,
	"./dy_icon_01.png": 4508,
	"./dy_icon_02.png": 1543,
	"./dy_icon_03.png": 5758,
	"./dy_icon_04.png": 321,
	"./dy_img.png": 686,
	"./gd_icon.png": 6652,
	"./hunan_map.png": 8960,
	"./hunan_map.webp": 141,
	"./number_card_bg.png": 577,
	"./rank_b.png": 9138,
	"./rank_y.png": 4241,
	"./ring_color_01.png": 9699,
	"./ring_color_02.png": 1368,
	"./ring_color_03.png": 9761,
	"./screen_bg.png": 8909,
	"./screen_bg.webp": 5598,
	"./time_icon.png": 4598,
	"./tooltip_bg.png": 1889,
	"./zd_img.png": 1789,
	"./娄底市_431300.png": 7976,
	"./娄底市_431300.webp": 2181,
	"./岳阳市_430600.png": 4297,
	"./岳阳市_430600.webp": 8850,
	"./常德市_430700.png": 5489,
	"./常德市_430700.webp": 8218,
	"./张家界市_430800.png": 1675,
	"./张家界市_430800.webp": 640,
	"./怀化市_431200.png": 6650,
	"./怀化市_431200.webp": 2216,
	"./株洲市_430200.png": 8691,
	"./株洲市_430200.webp": 2552,
	"./永州市_431100.png": 8041,
	"./永州市_431100.webp": 2018,
	"./湘潭市_430300.png": 295,
	"./湘潭市_430300.webp": 5924,
	"./湘西州_433100.png": 5522,
	"./湘西州_433100.webp": 6403,
	"./益阳市_430900.png": 4973,
	"./益阳市_430900.webp": 2334,
	"./衡阳市_430400.png": 4169,
	"./衡阳市_430400.webp": 898,
	"./邵阳市_430500.png": 1036,
	"./邵阳市_430500.webp": 897,
	"./郴州市_431000.png": 7892,
	"./郴州市_431000.webp": 5241,
	"./长沙市_430100.png": 6224,
	"./长沙市_430100.webp": 3341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;